module.exports = __webpack_public_path__ + "static/media/gadzety_kreatywne_03_C.70852096.png";